import type { AnyDomainEvent } from '@abastece/shared';
import { orderKey } from '@abastece/shared';
import type { ApplyResult, Reader } from '../state.js';

export async function reduceProveedor(
  event: AnyDomainEvent,
  read: Reader,
): Promise<ApplyResult | null> {
  const rev = orderKey(event);

  switch (event.type) {
    case 'proveedor.creado': {
      const p = event.payload;
      return {
        effects: [
          {
            kind: 'proveedor.upsert',
            id: p.proveedorId,
            row: {
              id: p.proveedorId,
              nombre: p.nombre,
              telefono: p.telefono ?? null,
              contacto: p.contacto ?? null,
              notas: p.notas ?? null,
              activo: true,
              rev,
            },
          },
        ],
        rejections: [],
      };
    }

    case 'proveedor.actualizado': {
      const p = event.payload;
      const existing = await read.proveedor(p.proveedorId);
      if (!existing) {
        return { effects: [], rejections: [{ eventId: event.id, reason: 'El proveedor no existe' }] };
      }
      const patch: Record<string, unknown> = {};
      if (p.nombre !== undefined) patch['nombre'] = p.nombre;
      if (p.telefono !== undefined) patch['telefono'] = p.telefono ?? null;
      if (p.contacto !== undefined) patch['contacto'] = p.contacto ?? null;
      if (p.notas !== undefined) patch['notas'] = p.notas ?? null;
      return { effects: [{ kind: 'proveedor.patch', id: p.proveedorId, rev, patch }], rejections: [] };
    }

    case 'proveedor.desactivado':
      return {
        effects: [
          { kind: 'proveedor.patch', id: event.payload.proveedorId, rev, patch: { activo: false } },
        ],
        rejections: [],
      };

    default:
      return null;
  }
}
